import React from 'react';

import classNames from 'classnames';
import {Button, Form, FormFeedback, FormGroup, Input, Label} from 'reactstrap';

import {REGEXP_FEEDBACK} from 'configs';

import usePublicContact from './usePublicContact';

import styles from './styles.module.scss';
import cx from 'classnames';

PublicContact.defaultProps = {
  showSubmit: true,
};

function PublicContact(props) {
  const {companyType, companyId, description, children, validation, callback} =
    props;
  const {isSubmittingContact, submitContact} = usePublicContact(
    companyType,
    companyId,
    validation,
    callback
  );

  return (
    <Form
      onSubmit={submitContact}
      noValidate
      className={cx(styles['public-contact'], 'mb-5')}
    >
      <div className={classNames(styles['gray-box'], 'px-5 py-3 mt-4')}>
        {description && <p className="mb-3">{description}</p>}

        <fieldset disabled={isSubmittingContact}>
          <FormGroup>
            <Label>Subject</Label>
            <Input name="enquires_name" autoComplete="off" required />
            <FormFeedback>{REGEXP_FEEDBACK.required}</FormFeedback>
          </FormGroup>

          {children}

          <FormGroup>
            <Label>Enquiry</Label>
            <Input
              type="textarea"
              name="enquires_description"
              rows="2"
              required
            />
            <FormFeedback>{REGEXP_FEEDBACK.required}</FormFeedback>
          </FormGroup>

          <Button
            block
            type="submit"
            style={{borderRadius: '5px'}}
            color="primary"
            className={styles['public-contact__submit']}
          >
            {isSubmittingContact ? 'Submitting...' : 'Submit'}
          </Button>
        </fieldset>
      </div>
    </Form>
  );
}

export default PublicContact;
